exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sdr-custom-tab-active[data-v-61e3222b]{color:#ab3b7a!important}.sdr-custom-tabs .v-item-group[data-v-61e3222b]{padding-left:0}", ""]);

// exports
